<template>
  <div class="d-flex justify-content-end align-items-end mt-3">
    <ul class="pager">
      <li @click.prevent="setCurrentPage(current - 1, 'left')" ><a :class="{disabled: current === 1}" href="#"><span class="icon-ico-chev-left"></span></a></li>
      <li v-for="link in links" :key="link" @click.prevent="setCurrentPage(link)"><a :class="{'active': current == link}" href="#"><span>{{link}}</span></a></li>
      <li @click.prevent="setCurrentPage(current + 1, 'right')"><a :class="{disabled: current === total}" href="#"><span class="icon-ico-chev-right"></span></a></li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["total", "current"],
  methods: {
    setCurrentPage(page, type) {
      if(!((type == 'left' && this.current === 1) || (type == 'right' && this.current === this.total))){
        this.$emit('setCurrentPage', page);
      }
    },
  },
  computed: {
    links: function() {
      const _links = Array.from({ length: this.total }, (_, idx) => idx + 1);

      return this.current <= 5
        ? _links.slice(0, 5)
        : this.current > this.total - 5
        ? _links.slice(this.total - 5, this.total)
        : _links.slice(this.current - 3, this.current + 2);
    }
  },
}
</script>

<style>

</style>